import { render } from "./chevron.vue?vue&type=template&id=1fff0052"
import script from "./chevron.vue?vue&type=script&lang=js"
export * from "./chevron.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jakobkennerberg/Coding/Skanetrafiken/New.Shared/ST.SharedLibrary/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__